const initialState = {
    data: [],
  };
  
const uliceAllReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ULICE_ALL':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default uliceAllReducer;